<template>
  <card-wrapper class="py-8">
    <number-chart :is-loading="isLoading"
                  :value="value"
                  title="Fully Automated"
                  id="fully-automated-number"
                  :hint="hint"
                  suffix="%"
    />
  </card-wrapper>
</template>

<script>
import NumberChart from '@/components/analytics/charts/NumberChart'
import CardWrapper from '@/components/base-components/CardWrapper'
import { CHART_TEXT } from '@/utils/text.constants'
import analyticsFilterModule from '@/store/modules/analytics-filter.module'
import { GRANULARITY_REQUEST } from '@/utils/filter.constants'
import analyticsModule from '@/store/modules/analytics.module'

export default {
  name: 'AnsweredByBotNumberChart',
  components: {
    NumberChart,
    CardWrapper
  },

  props: {
    requestTotal: {
      type: Number,
      default: 0
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },

  computed: {
    granularity: analyticsFilterModule.getGranularity,
    aggregatedAutomationOutcomes: analyticsModule.getAggregatedAutomationOutcomes,

    value() {
      if (this.requestTotal === 0) return '-'

      const total = this.granularity === GRANULARITY_REQUEST ?
        this.requestTotal :
        this.aggregatedAutomationOutcomes.reduce((sum, { count }) => sum + count, 0)
      const percentage = this.fullyAutomated / total * 100
      return percentage.toFixed(1)
    },

    fullyAutomated() {
      const { count = 0 } = this.aggregatedAutomationOutcomes.find(({ legendType }) => legendType === 'fullyAutomated') || {}
      return count
    },

    hint() {
      return GRANULARITY_REQUEST === this.granularity ?
        CHART_TEXT.REQUEST_ANSWERED_BY_BOT_HINT :
        CHART_TEXT.CONTACT_ANSWERED_BY_BOT_HINT
    }
  }
}
</script>
